import {
  CommonModule,
  DatePipe,
} from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  RouterModule,
  Routes,
} from '@angular/router';

import { LightboxModule } from 'ngx-lightbox';
import { NgxMaskModule } from 'ngx-mask';
import { AuthService } from 'src/app/auth/auth.service';
import { LoginGuard } from 'src/app/auth/loginGuard';
import { CoreModule } from 'src/app/core/core.module';
import { UserService } from 'src/app/core/services/v2/user.service';
import { MaterialModule } from 'src/app/material/material-module';
import { SharedModule } from 'src/app/shared/shared.module';

import {
  NgbCollapseModule,
  NgbModalModule,
} from '@ng-bootstrap/ng-bootstrap';

import { PatientProfileComponent } from './patient-profile.component';
import {
  PatientEmergencyContactEditComponent,
} from './profile-edit/patient-emergency-contact-edit/patient-emergency-contact-edit.component';
import { PatientCreditCardComponent } from './profile/patient-credit-card/patient-credit-card.component';

const routes: Routes = [
  {
    path: '',
    component: PatientProfileComponent,
    canActivate: [LoginGuard]
  }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModalModule,
    NgbCollapseModule,
    MaterialModule,
    LightboxModule,
    CoreModule,
    NgxMaskModule.forRoot(),
    RouterModule.forChild(routes),
    // MarketPlaceModule,
  ],
  declarations: [
    // Move to shared module because we are using it in physician patient profile.
    //PatientProfileComponent,
    // ProfilePatientInfoComponent,
    // ProfileAddressInfoComponent,
    // ProfileDriverLicenseComponent,
    // ProfileContactPreferencesComponent,
    // ProfileEmployementInfoComponent,
    // ProfileEmergencyContactInfoComponent,
    // AddressComponent,
    // ChildrenOrGuardianComponent,
    // PharmacyPreferencesComponent,
    // AdvancedDirectivesComponent,
    // SidebarPatientEditComponent,
    // PatientAddressEditComponent,
    // PatientDriverLicenseEditComponent,
    // PatientEmergencyContactEditComponent,
    // PatientChildrenGuardianEditComponent,
    // PatientAdvancedDirectiveEditComponent,
    // PatientPharmacyPreferencesEditComponent
    //PatientInsuranceComponent
    //PatientInsuranceEditComponent
    //PatientFinancialInfoComponent,
    //PatientFinancialInfoEditComponent
    //PatientMedicationAllergyComponent,
    //PatientMedicationAllergyEditComponent
    //PatientPastMedicalHistoryComponent,
    //PatientPastMedicalHistoryEditComponent,
    //PatientFamilyHistoryComponent,
    //PatientFamilyHistoryEditComponent
    //PatientSocialHistoryComponent,
    //PatientSocialHistoryEditComponent,
    //PatientSurgicalHistoryComponent,
    //PatientObGynHistoryComponent,
    //PatientSurgicalHistoryEditComponent,
    //PatientObGynHistoryEditComponent
    //PatientAllergiesComponent
    //PatientCreditCardComponent
  ],
  providers: [
    UserService,
    AuthService,
    LoginGuard,
    DatePipe
  ],
  bootstrap: [PatientProfileComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    PatientEmergencyContactEditComponent
  ],
  exports: [],
})

export class PatientProfileModule { }
